// extracted by mini-css-extract-plugin
export default {"stop_watch_container_container":"stop-watch-container_stop_watch_container_container__rqWl7","action":"stop-watch-container_action__Mx29u"};